import e,{keyframes as i}from"styled-components";import{theme as o}from"../../../../../theme.js";const a=i`
  0%, 100% {
    transform: rotate(0);
    transform-origin: 50% 50%;
  }
  10% {
    transform: rotate(8deg);
  }
  20%, 40%, 60% {
    transform: rotate(-10deg);
  }
  30%, 50%, 70% {
    transform: rotate(10deg);
  }
  80% {
    transform: rotate(8deg);
  }
  90% {
    transform: rotate(8deg);
  }

`,n=({active:r,error:t=!1})=>t?"#EA3100":r?"#2A71D4":"#CBD5E1",s=e.div`
  width: fit-content;
  > label {
    display: flex;
    align-items: center;
    gap: ${o.spacing*2}px;
    flex-direction: ${({labelPosition:r})=>r==="left"?"row-reverse":"row"};
    > input {
      display: none;
    }
  }
`,d=e.div`
  width: 34px;
  height: 14px;
  border-radius: ${o.radius}px;
  background-color: ${({active:r})=>r?o.colors.primary[50]:o.colors.gray[200]};
  position: relative;
  cursor: pointer;
  margin: 0 5px;
  animation: ${({error:r})=>r?a:"unset"};
  animation-duration: .7s;
  animation-timing-function: ease-in-out;
`,l=e.div`
  width: 20px;
  height: 20px;
  background-color: ${({active:r,error:t})=>n({active:r,error:t})};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: ${({active:r})=>r?"calc(100% - 15px)":"-5px"};
  transition: all .2s ease-in-out;
  transform: translateY(-50%);
  box-shadow: ${o.boxShadow};
`;export{l as Circle,s as Container,d as SliderContainer};
